
export const basicConfigFormValueDft = {
    groupName: undefined,
    traceHeader: undefined,
    traceHeaderChecked: false,
    routeHeader: undefined,
    serviceList: [],
};
export const baseLaneConfigFormValueDft = {
    baseLane: {
        laneName: undefined,
        labelSelectorKey: undefined,
        labelSelectorValue: undefined,
        serviceList: [],
    },
};
